export const TARGET_STATUSES = {
	READY: 'ready',
	SENT: 'sent',
	QUEUED: 'queued',
	FAILED: 'failed',
	DELETED: 'deleted',
	SKIPPED: 'skipped'
};
